<script lang="ts" setup>
interface BackgroundAuthProps {
  variant?: "login" | "register";
}
const { variant = "" } = defineProps<BackgroundAuthProps>();
</script>
<template>
  <div class="degrade-background">
    <div class="images-background">
      <img
        src="~/assets/images/background/circles-group-1.svg"
        alt="circles group 1"
        :class="{ 'circles-1': true, [variant]: true }"
      />
      <img
        src="~/assets/images/background/circles-group-2.svg"
        alt="circles group 2"
        class="circles-2"
      />
      <div class="lines-group lines-group-1">
        <div class="lines-container">
          <img
            src="~/assets/images/background/diagonal-line.svg"
            alt="diagonal line"
            class="line-1"
          />
          <img
            src="~/assets/images/background/diagonal-line.svg"
            alt="diagonal line"
            class="line-2"
          />
        </div>
      </div>
      <div class="lines-group lines-group-2">
        <div class="lines-container">
          <img
            src="~/assets/images/background/diagonal-line.svg"
            alt="diagonal line"
            class="line-1"
          />
          <img
            src="~/assets/images/background/diagonal-line.svg"
            alt="diagonal line"
            class="line-2"
          />
        </div>
      </div>
      <div class="lines-group lines-group-3">
        <div class="lines-container">
          <img
            src="~/assets/images/background/diagonal-line.svg"
            alt="diagonal line"
            class="line-1"
          />
          <img
            src="~/assets/images/background/diagonal-line.svg"
            alt="diagonal line"
            class="line-2"
          />
        </div>
      </div>
      <div class="lines-group lines-group-4">
        <div class="lines-container">
          <img
            src="~/assets/images/background/diagonal-line.svg"
            alt="diagonal line"
            class="line-1"
          />
          <img
            src="~/assets/images/background/diagonal-line.svg"
            alt="diagonal line"
            class="line-2"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.degrade-background {
  width: 100%;
  height: 100dvh;
  background: $gradient;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
}
.images-background {
  position: relative;
  width: 100%;
  height: 100dvh;
  overflow: hidden;
}
.circles-1 {
  position: absolute;
  bottom: 0px;
  left: 0px;
}
.circles-1.login {
  left: 20px;
  top: -50px !important;
}
.circles-2 {
  position: absolute;
  top: 20px;
  right: 20px;
}

.lines-group {
  position: absolute;
  width: 213px;
  height: 213px;
}
.lines-container {
  position: relative;
}
.line-1 {
  position: absolute;
  top: 100px;
  left: 0px;
}
.line-2 {
  position: absolute;
  top: 30px;
  left: 100px;
}

.lines-group-1 {
  top: 120px;
  left: -100px;
}
.lines-group-2 {
  right: 500px;
  top: -100px;
}
.lines-group-3 {
  bottom: 150px;
  right: 700px;
}
.lines-group-4 {
  bottom: 500px;
  right: 0px;
}
img {
  display: none;

  @media (min-width: $breakpoint-tablet) {
    display: block;
  }
}
</style>
